import { SDQuerySubscribersStore } from "../C_Sportsbook/Helpers";
import { getter, setter, STR_ERRORS, connectionStore, ClassDecoratorFactory } from "../Common";
import { ConnectionNames } from "../Contracts";
const connectionName = ConnectionNames.sports;
/**
 * You must not use arrow or bound functions for class methods that change the
 * `query` property. The decorator creates a Proxy instance that is responsible
 * for tracking `this.query` changes. If you change the context inside the
 * connection class changes to `this.query` will not be tracked.
 * @param callback (x: A, ...rest: any[]) => void
 * @param proxyHandler ProxyHandler<A>
 * @where A extends Object
 */
export const SportsbookConnection = ClassDecoratorFactory(
// this function is non awaitable!
// we can't reference it's return value in any way
(instance) => {
    const conn = connectionStore.get(connectionName);
    if (typeof conn === "undefined") {
        throw new Error(STR_ERRORS.NoConnectionsAvailable);
    }
    if (instance.query) {
        instance.query = instance.query;
    }
}, {
    get: getter,
    set: setter.bind(undefined, connectionName, SDQuerySubscribersStore)
});
//# sourceMappingURL=SportsbookConnection.js.map